import store from './redux/store'
import { getCallbacks } from './redux/modules/auth0/auth0.slice'

export { Auth0Provider } from '@auth0/auth0-react'
export * from './lib/hooks'
export { setConfig as configure } from './lib/config'
export { translateAuth0User } from './util/user'

export enum LoginAction {
    LOGIN = 'login',
    REGISTER = 'register',
}

const getAuth0Callbacks = () => getCallbacks(store.getState())

export { getAuth0Callbacks as getCallbacks }
